import React from "react";

import { Api, InfoOutlined, Javascript, ListAlt, ModelTraining, Person } from "@mui/icons-material";
import { Avatar, IconButton, List, ListItem, ListItemAvatar, ListItemText, Tooltip } from "@mui/material";
import { styled } from '@mui/material/styles';
import Popover from '@mui/material/Popover';
import Service from "../../../../util/Service";
import APICodeDialog from "./APICodeDialog";
import ModelosJSDialog from "./ModelosJSDialog";


const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

export default function ModeloCodigoPopover(props) {
    const { code, setCode } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openAPIDialog, setOpenAPIDialog]= React.useState(false);
    const [openJSDialog, setOpenJSDialog]= React.useState(false);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    function handleUserLogado(){
        console.log( code );
        const dado = {
            code: code
        }
        Service.POST("/api/security/model/codeUserProfile", dado).then(r =>{
            console.log( r );
            if( r.success){
                setCode( r.dado);
            }else{
                alert(r.msg)
            }

            handleClose();
        })
    }
    function handleUserTaskById(){
        console.log('>>>handleUserTaskById<<<', window.location.href )
        const arr = window.location.href.split("/");
        console.log( arr );

        const dado = {
            code: code,
            paths: arr
        }
        Service.POST("/api/security/codeUserProcessTask", dado).then(r =>{
            console.log( r );
            if( r.success){                
                setCode( r.dado);
            }else{
                alert(r.msg)
            }

            handleClose();
        })
    }
    function handleAddAlertaDialog(){
        console.log('>>>handleAddAlertaDialog<<<')
        const dado = {
            code: code
        }
        Service.POST("/api/security/model/codeDialogVery", dado).then(r =>{
            console.log( r );
            if( r.success){                
                setCode( r.dado);
            }else{
                alert(r.msg)
            }

            handleClose();
        })
    }
    function handleOpenAPIDIalog(){
        setOpenAPIDialog(true);
    }
    function handleOpenJSDIalog(){
        setOpenJSDialog(true);
    }

    return (
        <React.Fragment>
            <APICodeDialog open={openAPIDialog} onClose={()=> setOpenAPIDialog(false)} code={code} setCode={setCode}/>
            <ModelosJSDialog open={openJSDialog} onClose={()=> setOpenJSDialog(false)} />
            <Tooltip title="Modelo de codigo">
                <IB
                    variant='container'
                    onClick={handleClick}
                    size="small"
                >
                    <ModelTraining />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                    <ListItem sx={{cursor:'pointer'}} onClick={handleOpenJSDIalog}>
                        <ListItemAvatar>
                            <Avatar>
                                <Javascript />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="JS" secondary="Exemplos de codigo" />
                    </ListItem>

                    <ListItem sx={{cursor:'pointer'}} onClick={handleOpenAPIDIalog}>
                        <ListItemAvatar>
                            <Avatar>
                                <Api />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="API" secondary="Modelo Chamada API" />
                    </ListItem>
                    <ListItem sx={{cursor:'pointer'}} onClick={handleUserLogado}>
                        <ListItemAvatar>
                            <Avatar>
                                <Person />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Perfil" secondary="Pegar user Logado" />
                    </ListItem>                    
                    <ListItem sx={{cursor:'pointer'}} onClick={handleUserTaskById}>
                        <ListItemAvatar>
                            <Avatar>
                                <ListAlt />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Tarefa" secondary="Pegar tarefa de execução" />
                    </ListItem>

                    <ListItem sx={{cursor:'pointer'}} onClick={handleAddAlertaDialog}>
                        <ListItemAvatar>
                            <Avatar>
                                <InfoOutlined />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Alerta" secondary="Codigo de Alerta" />
                    </ListItem>

                </List>
            </Popover>
        </React.Fragment>
    )
}